// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"0842da8e-168":"ff55ed0573df86458dd0","0842da8e-452":"76b515592689c90b15a9","0842da8e-379":"a0db39b4fd84bbd38a55","0842da8e-83":"1cb601ee1b2a6b42c9e1"}[chunkId] + ".js";
};